export default "/images/vendor/@coreui/icons/svg/flag/cif-ru.svg?5b43db598b904f06011ada6d5f8d2680";